import React, { useState, useEffect, useRef } from 'react';

import TextInput from '../../../../../Form/TextInput';
import CurrencyInput from '../../../../../Form/CurrencyInput';

import { formatCurrency } from '../../../../../../helpers/currencyMask';

export default function EditableInput({
  value,
  isEdit,
  onClick,
  onChange,
  type,
}) {
  const [isClicked, setIsClicked] = useState(false);

  const editableInputRef = useRef();

  let content = (
    <div
      onClick={() => {
        onClick();
        setIsClicked(true);
      }}
    >
      {type === 'currency' ? `$${formatCurrency(value)}` : value}
    </div>
  );

  if (isEdit && type === 'text') {
    content = (
      <TextInput
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    );
  } else if (isEdit && type === 'currency') {
    content = (
      <CurrencyInput
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    );
  }

  // If the component is clicked, focus on the input
  useEffect(() => {
    if (isClicked) {
      const input = editableInputRef.current.querySelector('input');

      if (input) {
        input.focus();
      }
    }
  }, [isClicked]);

  return <div ref={editableInputRef}>{content}</div>;
}
